import React, {Component} from "react";
import facebook_logo from '../../images/facebook-brands.svg';

export class FacebookLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 20;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 20;

    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 15;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    render() {
        return <img alt="Facebook Ads" style={this.props.styles} src={facebook_logo} height={this.getHeight()} width={this.getWidth()} hspace={this.getHSpace()} vspace={this.getVSpace()}/>
    }
}
